// extracted by mini-css-extract-plugin
export var numpadContainer = "_n7-1";
export var phoneButton = "_n7-0";